import { User } from '../../models';

export interface UserRepository {
  getUserByUsername(username: string, caseSensitive?: boolean): User;
}
